<template>
  <div class="animated fadeIn">
    <div class="card">
      <div class="main-card-body">
        <div class="body-header d-flex">
          <h4>Quản lý ca</h4>
          <div class="text-right mb-3">
            <el-button
              v-if="mData.dataDefault.listFeature.includes('FT703')"
              @click="fn_handle('create')"
              class="btn-default"
              >Thêm mới</el-button
            >
          </div>
        </div>
        <div class="main-body">
          <!-- <b-row>
                        <b-col :class="'col-md-6'">
                        </b-col>
                        <b-col :class="'col-md-6'">
                            <div class="text-right mb-3">
                                <el-button
                                    @click="fn_handle('create')"
                                    round
                                >Thêm mới</el-button>
                            </div>
                        </b-col>
                    </b-row> -->
          <div class="main-body-table">
            <el-table
              :data="mData.tableRules.data"
              border
              @selection-change="fn_tableSelectionChange"
              @sort-change="fn_tableSortChange"
              style="width: 100%"
              :default-sort="{
                prop: mData.tableRules.defaultSort[0],
                order: mData.tableRules.defaultSort[1],
              }"
            >
              <el-table-column
                type="selection"
                width="40"
                v-if="mData.tableRules.allowSelect"
              ></el-table-column>
              <el-table-column label="STT" width="45">
                <template slot-scope="scope">
                  <div class="text-center">
                    {{ mData.tableRules.offset + scope.$index + 1 }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                prop="code"
                label="Mã ca"
                width="180"
              ></el-table-column>
              <el-table-column
                prop="name"
                label="Tên ca"
                min-width="230"
              ></el-table-column>
              <el-table-column
                prop="work_hour_number"
                label="Giờ công"
                min-width="90"
                align="center"
              ></el-table-column>
              <el-table-column
                prop="ten_nguoi_tao"
                label="Người tạo"
                min-width="180"
              ></el-table-column>
              <el-table-column
                label="Thời gian hiệu lực"
                min-width="150"
                align="center"
              >
                <template slot-scope="scope">
                  {{
                    scope.row.applied_start_time && scope.row.applied_end_time
                      ? scope.row.applied_start_time +
                        " - " +
                        scope.row.applied_end_time
                      : ""
                  }}
                </template>
              </el-table-column>
              <el-table-column
                :label="aLang.c_action"
                align="center"
                width="120px"
                v-if="
                  mData.dataDefault.listFeature.includes('FT702') ||
                  mData.dataDefault.listFeature.includes('FT704')
                "
              >
                <template slot-scope="scope">
                  <el-button
                    size="mini"
                    plain
                    round
                    @click="fn_handle('detail', scope.$index, scope.row)"
                    v-b-popover.hover.left="aLang.c_detail"
                    v-if="mData.dataDefault.listFeature.includes('FT702')"
                  >
                    <i class="fas fa-info-circle"></i>
                  </el-button>
                  <el-button
                    size="mini"
                    plain
                    round
                    @click="fn_handle('update', scope.$index, scope.row)"
                    v-b-popover.hover.left="aLang.c_update"
                    v-if="mData.dataDefault.listFeature.includes('FT704')"
                    type="primary"
                  >
                    <i class="far fa-edit"></i>
                  </el-button>
                </template>
              </el-table-column>
            </el-table>

            <b-row class="mt-2" v-if="mData.tableRules.allowPaging">
              <div class="col-md-4">
                <div v-if="mData.tableRules.allowSelect">
                  {{ aLang.c_select }}:
                  {{ mData.tableRules.recordSelected.length }}
                </div>
              </div>
              <div class="col-md-8 text-right">
                <el-pagination
                  @size-change="fn_tableSizeChange"
                  @current-change="fn_tableCurentChange"
                  @prev-click="fn_tablePrevClick"
                  @next-click="fn_tableNextClick"
                  :page-sizes="mData.tableRules.lengthMenu"
                  :page-size="mData.tableRules.limit"
                  :current-page="mData.tableRules.page"
                  background
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="mData.tableRules.total"
                  :pager-count="5"
                ></el-pagination>
              </div>
            </b-row>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LanguageService from "../../../../../service/LanguageService";
import MethodService from "../../../../../service/MethodService";
import ShiftModel from "./ShiftModel";
import ShiftApi from "../../../../../moduleApi/ShiftApi";
import ProfileApi from "../../../../../moduleApi/ProfileApi";

export default {
  data() {
    return {
      aLang: LanguageService.lang,
      aElement: MethodService.element,
      mData: {
        data: [],
        moduleName: "Shift", //requied
        dialogFormAddNewSalary: false,
        tableRules: MethodService.copyObject(ShiftModel.tableRules),
        dataDefault: {
          listNguoiTao: [],
          listFeature: MethodService.getListFeatures(),
        },
      },
    };
  },

  methods: {
    async fn_initTable() {
      let dataFilter = {
        filters: this.mData.tableRules.filters,
      };
      if (this.mData.tableRules.allowPaging) {
        dataFilter.limit = this.mData.tableRules.limit;
        dataFilter.offset = this.mData.tableRules.offset;
      }
      if (this.mData.tableRules.showUrl) {
        this.$router
          .replace({
            name: "Admin-Timekeeping-TimekeepingConfig-Shift-list",
            query: {
              limit: this.mData.tableRules.limit,
              page: this.mData.tableRules.page,
            },
          })
          .catch((err) => {});
      }
      let res = await ShiftApi.list(dataFilter);
      if (res.result) {
        let resData = await this.fn_changeData(res.result);
        this.mData.tableRules.data = resData;
        this.mData.tableRules.total = res.meta.total;
        if (resData) {
          this.mData.tableRules.page = this.mData.tableRules.offset / this.mData.tableRules.limit + 1;
          if(
              this.mData.tableRules.offset == this.mData.tableRules.total &&
              this.mData.tableRules.page > 1
            ) {
            this.mData.tableRules.page = this.mData.tableRules.page - 1;
            this.mData.tableRules.offset = (this.mData.tableRules.page - 1) * this.mData.tableRules.limit;
            this.fn_initTable();
          }
        }
      }
    },
    //xử lý dữ liệu đầu ra
    async fn_changeData(resData) {
      let nguoiTaoIds = [];
      nguoiTaoIds = MethodService.findListItemDifferent(
        resData,
        "created_user_id"
      );
      const reqNguoiTaoApi = await ProfileApi.list({
        limit: nguoiTaoIds.length,
        filters: "id:in:" + nguoiTaoIds.join(","),
      });
      let resNguoiTaoApi = await reqNguoiTaoApi;

      this.mData.dataDefault.listNguoiTao = resNguoiTaoApi.result;
      resData.forEach((row) => {
        row.applied_start_time = MethodService.formatDate(
          row.applied_start_time,
          "date"
        );
        row.applied_end_time = MethodService.formatDate(
          row.applied_end_time,
          "date"
        );
        let nguoiTao = this.mData.dataDefault.listNguoiTao.find((element) => {
          return element.id == row.created_user_id;
        });
        if (nguoiTao && nguoiTao.name && nguoiTao.name.full_name) {
          row.ten_nguoi_tao = nguoiTao.name.full_name;
        } else {
          row.ten_nguoi_tao = " ";
        }
        let time = "";
        if (
          row.work_days[0].period_time[0].start_time.hour &&
          row.work_days[0].period_time[1].start_time.hour
        ) {
          time =
            (row.work_days[0].period_time[0].start_time.hour < 10
              ? "0" + row.work_days[0].period_time[0].start_time.hour
              : row.work_days[0].period_time[0].start_time.hour) +
            ":" +
            (row.work_days[0].period_time[0].start_time.minute < 10
              ? "0" + row.work_days[0].period_time[0].start_time.minute
              : row.work_days[0].period_time[0].start_time.minute) +
            " - " +
            (row.work_days[0].period_time[1].end_time.hour < 10
              ? "0" + row.work_days[0].period_time[1].end_time.hour
              : row.work_days[0].period_time[1].end_time.hour) +
            ":" +
            (row.work_days[0].period_time[1].end_time.minute < 10
              ? "0" + row.work_days[0].period_time[1].end_time.minute
              : row.work_days[0].period_time[1].end_time.minute);
        } else if (row.work_days[0].period_time[0].start_time.hour) {
          time =
            (row.work_days[0].period_time[0].start_time.hour < 10
              ? "0" + row.work_days[0].period_time[0].start_time.hour
              : row.work_days[0].period_time[0].start_time.hour) +
            ":" +
            (row.work_days[0].period_time[0].start_time.minute < 10
              ? "0" + row.work_days[0].period_time[0].start_time.minute
              : row.work_days[0].period_time[0].start_time.minute) +
            " - " +
            (row.work_days[0].period_time[0].end_time.hour < 10
              ? "0" + row.work_days[0].period_time[0].end_time.hour
              : row.work_days[0].period_time[0].end_time.hour) +
            ":" +
            (row.work_days[0].period_time[0].end_time.minute < 10
              ? "0" + row.work_days[0].period_time[0].end_time.minute
              : row.work_days[0].period_time[0].end_time.minute);
        } else {
          time = "";
        }
        row.work_hour_number = time;
      });
      return resData;
    },
    //event table
    fn_tableSelectionChange(val) {
      var _this = this;
      this.mData.tableRules.recordSelected = [];
      val.forEach(function (element) {
        _this.mData.tableRules.recordSelected.push(element.id);
      });
    },

    fn_tableSortChange(column) {
      if (column.order == "ascending") {
        this.mData.tableRules.sort = column.prop;
      } else if (column.order == "descending") {
        this.mData.tableRules.sort = "-" + column.prop;
      } else {
        this.mData.tableRules.sort = "";
      }
      this.fn_initTable();
    },
    fn_handle(type, scope, row) {
      if (type == "create") {
        this.$router.push({
          name:
            "Admin-Timekeeping-TimekeepingConfig-" +
            this.mData.moduleName +
            "-create",
        });
      }
      if (type == "detail") {
        this.$router.push({
          name:
            "Admin-Timekeeping-TimekeepingConfig-" +
            this.mData.moduleName +
            "-detail",
          params: { id: row.id },
        });
      }
      if (type == "update") {
        this.$router.push({
          name:
            "Admin-Timekeeping-TimekeepingConfig-" +
            this.mData.moduleName +
            "-update",
          params: { id: row.id },
        });
      }
    },
    //event table
    fn_tableSizeChange(limit) {
      this.mData.tableRules.limit = limit;
      this.fn_tableChangeOffset(this.mData.tableRules.page);
    },
    fn_tableCurentChange(page) {
      this.fn_tableChangeOffset(page);
    },
    fn_tablePrevClick(page) {
      this.fn_tableChangeOffset(page);
    },
    fn_tableNextClick(page) {
      this.fn_tableChangeOffset(page);
    },
    fn_tableChangeOffset(page) {
      this.mData.tableRules.page = page;
      this.mData.tableRules.offset =
        (this.mData.tableRules.page - 1) * this.mData.tableRules.limit;
      this.fn_initTable();
    },
    fn_hashUrl() {
      if (this.$route.query.limit) {
        this.mData.tableRules.limit = parseInt(this.$route.query.limit);
      }
      if (this.$route.query.page) {
        this.mData.tableRules.page = parseInt(this.$route.query.page);
      }
      if (this.$route.query.limit && this.$route.query.page) {
        this.mData.tableRules.offset =
          (this.mData.tableRules.page - 1) * this.mData.tableRules.limit;
      }
      if (this.$route.query.sort) {
        this.mData.tableRules.sort = this.$route.query.sort;
        this.mData.tableRules.defaultSort[0] = this.mData.tableRules.sort;
        if (this.mData.tableRules.sort.indexOf("-") != -1) {
          this.mData.tableRules.defaultSort[1] = "descending";
        } else {
          this.mData.tableRules.defaultSort[1] = "ascending";
        }
      }

      if (this.$route.query.filters) {
        this.mData.tableRules.filters = this.$route.query.filters;
        // string to object
        this.mData.tableRules.dataSearch.value = MethodService.stringToObject(
          this.mData.tableRules.filters
        );
      }
    },
  },

  //run after render view
  async created() {
    await this.fn_hashUrl();
    this.fn_initTable();
  },
  mounted() {},
};
</script>
<style scoped>
::v-deep .el-dialog {
  width: 60%;
}
</style>
